import type { Notification } from '../types/notification.types'

export const mockNotifications: Notification[] = [
    {
        id: 'NOT-001',
        title: 'Order Confirmed',
        message: 'Your order ORD-001 has been confirmed',
        type: 'success',
        recipient: 'john@example.com',
        channel: 'email',
        status: 'sent',
        createdAt: '2024-12-24 10:30',
        sentAt: '2024-12-24 10:31',
    },
    {
        id: 'NOT-002',
        title: 'Payment Received',
        message: 'Payment of ₹15,000 received for order ORD-001',
        type: 'success',
        recipient: 'mike@abc.com',
        channel: 'sms',
        status: 'sent',
        createdAt: '2024-12-24 11:00',
        sentAt: '2024-12-24 11:01',
    },
    {
        id: 'NOT-003',
        title: 'KYC Verification Required',
        message: 'Please complete your KYC verification',
        type: 'warning',
        recipient: 'sarah@xyz.com',
        channel: 'email',
        status: 'pending',
        createdAt: '2024-12-25 09:00',
    },
    {
        id: 'NOT-004',
        title: 'Order Shipped',
        message: 'Your order has been shipped and is on the way',
        type: 'info',
        recipient: 'bob@example.com',
        channel: 'push',
        status: 'failed',
        createdAt: '2024-12-25 10:00',
        failureReason: 'Invalid device token',
    },
]
